import { Component, OnInit, HostListener, ElementRef } from '@angular/core';
import { ViewportScroller} from '@angular/common';
import * as $ from 'jquery';
import 'jquery';
import '../../../assets/js/material-kit';
import '../../../assets/js/jquery';
import '../../../assets/js/nicepage';

import {NavigatorService} from "../../services/navigatorService/navigator.service";
import {BootstrapNotifyService} from "../../services/bootstrap-notify/bootstrap-notify.service";
import {IResponse} from "../../interfaces/iresponse";
import {UserService} from "../../services/api-handlers/userService/user.service";
import {environment as env} from "../../../environments/environment";

@Component({
  selector: 'app-landing-page',
  templateUrl: './landing-page.component.html',
  styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit {
  pageYoffset = 0;
  public credentials = {
    email: null
  };
  public year: number = new Date().getFullYear();
  public loading = false;

  @HostListener('window:scroll', ['$event']) onScroll(event) {
    this.pageYoffset = window.pageYOffset;
  }

  constructor(private userService: UserService, private scroll: ViewportScroller, private navigationService: NavigatorService, private bootstrapService: BootstrapNotifyService) {
  }

  openHome() {
    this.navigationService.navigateUrl("/login");
  }

  scrollToAbout() {

    if ($('.section-story-overview').length != 0) {
      $("html, body").animate({
        scrollTop: $('.section-story-overview').offset().top
      }, 1000);
    }
  };

  scrollToContact() {

    if ($('.section-contact-us').length != 0) {
      $("html, body").animate({
        scrollTop: $('.section-contact-us').offset().top
      }, 1000);
    }
  };

  ngOnInit(): void {
    // // menu fixed js code
    /*$(window).scroll(function () {
      let window_top = $(window).scrollTop();
      if (window_top > 200) {
        $('.navbar-color-on-scroll').removeClass('navbar-transparent');
      } else {
        $('.navbar-color-on-scroll').addClass('navbar-transparent');
      }
    });*/

    const navbar = document.querySelector('.navbar-color-on-scroll');
    window.onscroll = () => {
      if (window.scrollY > 300) {
        navbar.classList.remove('navbar-transparent');
      } else {
        navbar.classList.add('navbar-transparent');
      }
    };

    /*$(window).scroll(function () {
      let window_top = $(window).scrollTop() + 1;
      if (window_top > 50) {
        $('.main_menu').addClass('menu_fixed animated fadeInDown');
      } else {
        $('.main_menu').removeClass('menu_fixed animated fadeInDown');
      }
    });*/
  }

  public subscribeProcess() {
    if (!this.credentials.email) {
      return this.bootstrapService.error('Please Provide your Email Address to Proceed!!');
    } else {
      this.loading = true;
      this.userService.emailSubscribe(this.credentials).subscribe((res: any) => {
        console.log('Subscribe Details', this.credentials);
        this.loading = false;
        setTimeout(() => {
          this.bootstrapService.success(res.message || 'Successful');
        }, 5000);  //5s
      }, error => {
        this.loading = false;
        console.log('Signup Error Data', this.credentials);
        this.bootstrapService.error(error.error.errors, error.error.status);
        /*this.bootstrapService.error(error.status || 'Unable to Process Signup');*/
      });
    }
  }

    scrollToTop() {
      this.scroll.scrollToPosition([0, 0]);
    }

}
